import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import { setTextBlockClasses } from '../../accordion-item/layout/renderAccordionItem.js';
import { getRandomNumber } from '../../../utilities/math/index.js';
import { scrollIntoView } from '../../../utilities/behavior-helpers/index.js';
import { isRTL, isSafari } from '../../../utilities/dom-helpers/index.js';
import { trackLeadershipBiographyOpened } from '../../../utilities/lead-forensics/index.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';

const id = `acc-content-${getRandomNumber().toString(16).slice(2)}`;
// check if text block inside the accordion content has element with 'id' that equals to url hash
const isAnchorInsideContent = (node) => {
    const { hash } = document.location;
    if (!hash)
        return false;
    const contentSlot = node.querySelector('slot');
    if (!contentSlot)
        return false;
    const content = contentSlot.assignedNodes()[0];
    if (!content)
        return false;
    const textBlock = content.querySelector('text-block');
    if (!textBlock)
        return false;
    return !!textBlock.querySelector(`[id='${hash.slice(1)}']`);
};
const getClosestLeadershipGroupName = (ctx) => {
    const tabPanel = ctx.closest('tab-item-updated');
    const panelId = tabPanel === null || tabPanel === void 0 ? void 0 : tabPanel.id;
    if (!panelId)
        return null;
    const escapedPanelId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(panelId)
        : panelId.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const tabButton = document.querySelector(`button[role="tab"][aria-controls="${escapedPanelId}"]`);
    const groupName = (tabButton === null || tabButton === void 0 ? void 0 : tabButton.getAttribute('name')) || (tabButton === null || tabButton === void 0 ? void 0 : tabButton.textContent);
    return (groupName === null || groupName === void 0 ? void 0 : groupName.trim()) || null;
};
const getStableBiographyIdentifier = (ctx) => {
    var _a;
    const biographyContent = ctx.querySelector('[slot="image-accordion-content"]');
    const contentWithId = biographyContent === null || biographyContent === void 0 ? void 0 : biographyContent.querySelector('[id]');
    return ((_a = contentWithId === null || contentWithId === void 0 ? void 0 : contentWithId.id) === null || _a === void 0 ? void 0 : _a.trim()) || undefined;
};
const renderImageAccordionItem = (ctx) => {
    setTimeout(() => {
        if (isAnchorInsideContent(ctx.renderRoot.querySelector('.content'))) {
            ctx.isExpanded = true;
            scrollIntoView(ctx.renderRoot.querySelector('.header'), document.querySelector('.container > .top'));
        }
        const contentSlot = ctx.renderRoot.querySelector('slot');
        if (!contentSlot)
            return;
        const content = contentSlot.assignedNodes()[0];
        if (!content)
            return;
        const textBlocks = content.querySelectorAll('text-block');
        setTextBlockClasses(textBlocks);
    }, 0);
    return $ `<button class="header ${ctx.rtl || isRTL() ? 'rtl' : ''}" ?active="${ctx.isExpanded}" @click="${(e) => {
        const target = e.currentTarget;
        const wasExpanded = (target === null || target === void 0 ? void 0 : target.getAttribute('aria-expanded')) === 'true';
        ctx.handleClick(e);
        const isExpanded = (target === null || target === void 0 ? void 0 : target.getAttribute('aria-expanded')) === 'true';
        if (!wasExpanded && isExpanded && ctx.title) {
            const leadershipGroupName = getClosestLeadershipGroupName(ctx);
            if (leadershipGroupName) {
                trackLeadershipBiographyOpened({
                    personName: ctx.title,
                    groupName: leadershipGroupName,
                    stableIdentifier: getStableBiographyIdentifier(ctx),
                });
            }
        }
        target === null || target === void 0 ? void 0 : target.scrollIntoView();
        setTimeout(() => {
            if (isSafari)
                target === null || target === void 0 ? void 0 : target.scrollIntoView();
        }, 300);
    }}" @keyDown="${ctx.handleClick}" aria-expanded="${ctx.isExpanded ? 'true' : 'false'}" aria-controls="${id}"><img class="image" src="${l(ctx.image)}" alt="${l(ctx.imageAlt)}"><div class="text"><p class="title">${o(ctx.title)}</p><p class="subtitle">${o(ctx.subtitle)}</p></div><div class="icon"></div><hr></button><div class="content" id="${id}"><div class="inner"><slot name="image-accordion-content"></slot></div></div>`;
};

export { renderImageAccordionItem };
